import { Component, OnInit } from "@angular/core";
import { User } from "../../_models/user";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { AlertService } from "../../_services/alert.service";
//import {LocalStorageService,SessionStorageService,LocalStorage,SessionStorage,} from "angular-web-storage";
import { environment } from "../../../environments/environment";
import { ApiIntegration } from "../../_services/api.integration";
import { Globals } from "../../_models/globals";

@Component({
  selector: "app-admin-configuration",
  templateUrl: "./admin-configuration.component.html",
  styleUrls: ["./admin-configuration.component.scss"],
})
export class AdminConfigurationComponent implements OnInit {
  uploadDocketNumbers: string;
  uploadPackageNumbers: string;
  fileUploadError: string = "";
  fileUpload: string = "";
  carrier: string = "";
  carrierError: string = "";
  trackingNumber: any;
  filename: any;
  paymentType: string;
  paymentTypeError: string;
  subType: string;
  subTypeError: string;
  constructor(
    private alertService: AlertService,
    private http: HttpClient,
    private api: ApiIntegration,
    private g: Globals,
    public user: User
  ) {
    this.carrier = "GT";
    if (this.carrier == "GT") {
      this.trackingNumberFunction("GT");
    }
  }

  paymentTypeBlur() {
    this.paymentTypeError = "";
    if (!this.paymentType) {
      this.paymentTypeError = "please select paymentType";
    }
  }

  subTypeBlur() {
    this.subTypeError = "";
    if (!this.subType) {
      this.subTypeError = "please select subtype";
    }
  }

  trackingNumberFunction(carrierCode) {
    this.trackingNumber = undefined;
    this.paymentType = "";
    this.paymentTypeError = "";
    this.g.loaderDisplay = "display";
    this.filename = "";
    this.fileUpload = "";
    this.api.getAvailableTrackingNumberDetails(carrierCode).subscribe(
      (data: any) => {
        this.g.loaderDisplay = "";
        this.trackingNumber = data;
        if (data["code"] == 200) {
          this.alertService.success("Success", data["message"]);
        } else if (data["code"] == 400) {
          this.alertService.error("Error", data["message"]);
        } else {
          this.alertService.error("Error", data["message"]);
        }
      },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
      }
    );
  }

  ngOnInit() { }

  loadOrder(event) {
    this.fileUploadError = "";
    this.fileUpload = event.target.files[0];
  }

  removeFile() {
    this.fileUpload = "";
  }

  getFileName(fileupload): string {
    this.filename = fileupload.replace(/^.*[\\\/]/, "");
    return this.filename;
  }

  submitConfiguration() {
    this.fileUploadError = "";
    const file = this.fileUpload;
    if (file == "" || file === null) {
      this.fileUploadError = "please select file";
      return false;
    }
    const formData: FormData = new FormData();
    formData.append("file", file);
    var headerObj = new HttpHeaders();
    headerObj = headerObj.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(
        environment.apiUrl +
        "api/uploadTrackingDetails?carrierCode=" +
        this.carrier,
        formData,
        { headers: headerObj }
      )
      .subscribe(
        (data) => {
          if (data["code"] == 200) {
            this.alertService.success("Success", "You successfully uploaded !");
            this.trackingNumberFunction(this.carrier);
            this.filename = "";
            this.fileUpload = "";
          } else if (data["code"] == 400) {
            this.alertService.error("Error", data["message"]);
          } else {
            this.alertService.error("Error", data["message"]);
          }
        },
        (err: HttpErrorResponse) => {
          console.log(err);
        }
      );
  }

  submitPaymentType() {
    this.paymentTypeError = "";
    this.subTypeError = "";

    if (!this.paymentType) {
      this.paymentTypeError = "Please select paymentType";
    }
    if (!this.subType) {
      this.subTypeError = "please select Subtype";
    }

    if (this.paymentTypeError != "" || this.subTypeError != "") {
      return false;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(
        environment.apiUrl +
        "api/uploadTrackingDetailsForEcomExpress?carrierCode=" +
        this.carrier +
        "&paymentMethod=" +
        this.paymentType +
        "&subType=" +
        this.subType,
        {},
        { headers: header1 }
      )
      .subscribe(
        (data) => {
          this.g.loaderDisplay = "";
          if (data["code"] == "200") {
            this.alertService.success("paymentType", data["message"]);
            this.trackingNumberFunction(this.carrier);
          } else if (data["code"] == "400") {
            this.alertService.error("Error", data["message"]);
          }
        },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      );
  }
}
